import React from 'react';
import { ChevronRightIcon } from '@interstate/components/Icons/ChevronRightIcon';
import { InformationCircleIcon } from '@interstate/components/Icons/InformationCircleIcon';
import { Tooltip } from '@interstate/components/Tooltip';
import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';
import { TextInput } from '@interstate/components/TextInput';

import { useProgramField } from './hooks/useProgramField';

type ProgramFieldProps = {
    onProgramSlideOutOpen?: () => void;
};

const PROGRAM_FIELD_TEST_ID = 'program-field';

const ProgramField = ({ onProgramSlideOutOpen }: ProgramFieldProps) => {
    const theme = useInterstateTheme();
    const { label, value, upqWarning, onLabelActivate, onLabelKeyDown } = useProgramField({ onProgramSlideOutOpen });

    return (
        <>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <label
                    className="base-deal-activity-control-custom-label"
                    htmlFor={PROGRAM_FIELD_TEST_ID}
                    data-testid={`${PROGRAM_FIELD_TEST_ID}-label`}
                    style={{
                        marginBottom: '0.3rem',
                        width: 'fit-content'
                    }}
                    onClick={onLabelActivate}
                    onKeyDown={onLabelKeyDown}
                    tabIndex={0}
                    role="button"
                >
                    {label}
                    <ChevronRightIcon fontSize={10} />
                </label>
                {/* Warns that values may no longer match the program the deal started with. Only shows when
                    Auto Select is off, so it never collides with anything shown only while it is on. */}
                {upqWarning && (
                    <Tooltip
                        id="program-upq-warning-tooltip"
                        data-testid="program-upq-warning-tooltip"
                        toolTipContent={upqWarning}
                        position="bottom"
                        size="large"
                    >
                        <span
                            data-testid="program-upq-warning-tap-target"
                            style={{
                                display: 'inline-flex',
                                justifyContent: 'center',
                                width: '44px'
                            }}
                        >
                            <InformationCircleIcon data-testid="program-upq-warning-icon" color={theme.tokens.BaseColorBlue500} />
                        </span>
                    </Tooltip>
                )}
            </div>
            <TextInput
                size="sm"
                id={PROGRAM_FIELD_TEST_ID}
                data-testid={PROGRAM_FIELD_TEST_ID}
                name={label}
                displayLabel={false}
                readOnly={true}
                disabled={true}
                value={value}
                sx={{ lineHeight: '31px', display: 'inline-block' }}
            />
        </>
    );
};

export default ProgramField;
